import { render, staticRenderFns } from "./DocBasicInfo.vue?vue&type=template&id=6893727a&scoped=true&"
import script from "./DocBasicInfo.vue?vue&type=script&lang=js&"
export * from "./DocBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocBasicInfo.vue?vue&type=style&index=0&id=6893727a&lang=less&scoped=true&"
import style1 from "./DocBasicInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893727a",
  null
  
)

export default component.exports